import { cn } from '@flowstate/utils';

export interface HolographicCardProps {
  children: React.ReactNode;
  className?: string;
  interactive?: boolean;
}

export function HolographicCard({
  children,
  className,
  interactive = false,
}: HolographicCardProps) {
  return (
    <div
      className={cn(
        "rounded-xl p-[1px] bg-gradient-to-br from-primary/40 via-transparent to-primary/40 transition-all duration-300",
        interactive && "hover:from-primary/70 hover:via-primary/20 hover:to-primary/70 hover:shadow-[0_0_40px_-12px_var(--primary)]",
        className
      )}
    >
      <div
        className={cn(
          "h-full rounded-xl bg-card/40 backdrop-blur-md border border-white/5 p-6",
          interactive && "transition-colors duration-300 hover:bg-card/60"
        )}
      >
        {children}
      </div>
    </div>
  );
}
